import React, {Component} from 'react';
import PropTypes from 'prop-types';

import 'sass/ui-kit-page.scss';

import 'sass/SelectButtons.scss';

export default class SelectButtons extends Component {
    constructor(props) {
        super(props);
        this.state = {value: props.defaultValue ? props.defaultValue : props.values[0]};
        this.onButtonClick = this.onButtonClick.bind(this);
    }

    onButtonClick(value) {
        return (event) => {
            event.preventDefault();
            this.setState({value});
        }
    }

    renderButton({title, active = false}) {
        let className = "ui-button ui-mini";
        if (active) className += " primary";
        return (<button key={title} className={className} onClick={this.onButtonClick(title)}>{title}</button>);
    }

    render() {
        return (<div className="select-buttons">
            <input value={this.state.value} name={this.props.name} type="hidden"/>
            {this.props.values.map( (item) => {
                return this.renderButton({ title: item, active: item === this.state.value })
            }) }
        </div>)
    }
}

SelectButtons.propTypes = {
    name: PropTypes.string,
    active: PropTypes.bool,
    values: PropTypes.arrayOf(PropTypes.node).isRequired,
    defaultValue: PropTypes.node
};



// WEBPACK FOOTER //
// ./src/components/SelectButtons.js